/* eslint-disable max-len */
/* eslint-disable no-unused-vars */
/* eslint-disable no-use-before-define */
/* eslint-disable no-await-in-loop */
/* eslint-disable no-plusplus */
/* eslint-disable no-promise-executor-return */
/* eslint-disable consistent-return */
/* eslint-disable camelcase */
import $ from 'jquery';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Router from './router/Router';

function App() {
  // init tawk script
  // const tawkScript = () => {
  //   const s1 = document.createElement('script');
  //   s1.async = true;
  //   s1.src = 'https://embed.tawk.to/60ae92906699c7280da9110d/1f6kup1u7';
  //   s1.charset = 'UTF-8';
  //   s1.setAttribute('crossorigin', '*');
  //   document.body.appendChild(s1);
  // };
  // const retryTawkScript = async (maxRetries = 3, delay = 2000) => {
  //   for (let i = 0; i < maxRetries; i++) {
  //     try {
  //       await tawkScript();
  //       return; // Success, exit the function
  //     } catch (error) {
  //       console.log(`Attempt ${i + 1} failed. ${i < maxRetries - 1 ? 'Retrying...' : 'Max retries reached.'}`);
  //       if (i < maxRetries - 1) {
  //         await new Promise((resolve) => setTimeout(resolve, delay));
  //       }
  //     }
  //   }
  // };
  const disableNitro = () => {
    $(document).ready(() => {
      setTimeout(() => {
        // var tag_new = $("template").eq(38).attr("id");
        const tag_new = $('template').last().attr('id');
        // alert(tag_new);
        $(`#${tag_new}`).css('display', 'none');
        $(`#${tag_new}`).next().next().css('display', 'none');
      }, 100);
    });
  };

  // useEffect(() => {
  //   // Initialize Tawk with retry mechanism
  //   retryTawkScript();
  //   disableNitro();

  //   // Cleanup function
  //   return () => {
  //     // Remove Tawk script if component unmounts
  //     const tawkScript = document.querySelector('script[src*="tawk.to"]');
  //     if (tawkScript) {
  //       tawkScript.remove();
  //     }
  //     // Clean up any Tawk_API references
  //     if (window.Tawk_API) {
  //       window.Tawk_API = null;
  //       window.Tawk_LoadStart = null;
  //     }
  //   };
  // }, []);

  // new tawk script with error handling--
  // Initialize tawk script with error handling and retry mechanism
  // const tawkScript = () => new Promise((resolve, reject) => {
  //   try {
  //     // Check if script is already loaded
  //     if (window.Tawk_API) {
  //       console.log('Tawk script already loaded');
  //       return resolve();
  //     }

  //     const script = document.createElement('script');
  //     script.async = true;
  //     script.src = 'https://embed.tawk.to/60ae92906699c7280da9110d/1f6kup1u7';
  //     script.charset = 'UTF-8';
  //     script.setAttribute('crossorigin', '*');

  //     // Add load event listener
  //     script.addEventListener('load', () => {
  //       console.log('Tawk script loaded successfully');
  //       resolve();
  //     });

  //     // Add error event listener
  //     script.addEventListener('error', (error) => {
  //       console.error('Error loading Tawk script:', error);
  //       reject(error);
  //     });

  //     // Add script to document
  //     document.body.appendChild(script);

  //     // Set a timeout for script loading
  //     setTimeout(() => {
  //       if (!window.Tawk_API) {
  //         const error = new Error('Tawk script load timeout');
  //         console.error(error);
  //         reject(error);
  //       }
  //     }, 10000); // 10 second timeout
  //   } catch (error) {
  //     console.error('Error in tawkScript:', error);
  //     reject(error);
  //   }
  // });

  // useEffect(() => {
  //   tawkScript();
  //   disableNitro();
  // }, []);

  return (
    <>
      <Router />
      <ToastContainer hideProgressBar icon={false} />
    </>
  );
}

export default App;
